import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getVolunteers,
  deleteVolunteer,
  getNextVolunteers,
  getPreviousVolunteers,
} from "../../store/actions/volunteers_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/volunteers_enum";
import DataTable from "../../components/common/DataTable";
const AllVolunteers = ({
  getVolunteers,
  deleteVolunteer,
  getNextVolunteers,
  getPreviousVolunteers,
  volunteer: { loading, volunteers },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteVolunteer(deleteEntry);
      }
      getVolunteers({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (volunteers && volunteers.length === LIMIT) {
      const lastVolunteer = volunteers[volunteers.length - 1];
      getNextVolunteers({ last: lastVolunteer });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastVolunteer = volunteers[0];
      getPreviousVolunteers({
        first: lastVolunteer,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getVolunteers({ term: term, termField: termField });
    }
  };
  const deleteVolunteerClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getVolunteers({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Volunteers"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Volunteer"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="volunteers" title="Volunteer" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={volunteers}
                      field={"volunteers"}
                      page={page}
                      deleteBtnClicked={deleteVolunteerClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={volunteers}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ volunteer: state.volunteer });

const mapDispatchToProps = {
  getVolunteers,
  deleteVolunteer,
  getNextVolunteers,
  getPreviousVolunteers,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllVolunteers);
